/** Shared remote asset URLs used across the app. */

/** HAAT brand logo (Webflow CDN). */
export const HAAT_LOGO_URL =
  'https://cdn.prod.website-files.com/6829acf870093a50cc6ceb69/682b03419ead6e45d8f2c59e_logo%20(2).svg';

/** Partnership illustration shown on the public landing page hero. */
export const PARTNERSHIP_HERO_URL =
  'https://cdn.prod.website-files.com/6829acf870093a50cc6ceb69/688a163b2502fc79310e23dd_CTA%20Navigation%20-%201024_%201024%20.webp';

/**
 * Partner hero shown on the landing page and registration split layout.
 * Hosted on HAAT Nexus blob storage.
 */
export const PARTNER_CONNECT_HERO_URL =
  'https://haatnexusprodinfosys.blob.core.windows.net/images/ChatGPT%20Image%20Aug%2016,%202026,%2003_36_35%20PM%20(1).png';

/**
 * Promotional videos shown on the public landing page showcase section.
 * Hosted on the HAAT Nexus blob storage. Kept as a list so the showcase can
 * render them in a responsive grid.
 */
export const LANDING_SHOWCASE_VIDEO_URLS = [
  'https://haatnexusprodinfosys.blob.core.windows.net/images/landing_page_v_1.mp4',
  'https://haatnexusprodinfosys.blob.core.windows.net/images/landing_page_v_2.mp4',
];

/**
 * Partner brand logos shown in the landing-page "trusted by" marquee.
 * Served from the HAAT image CDN (im.haat.delivery).
 */
export const PARTNER_LOGO_URLS = [
  'https://im.haat.delivery/images/BusinessIcons/0_2025_10_13_12_37_26_114_original.jpg',
  'https://im.haat.delivery/images/BusinessIcons/0_2025_10_13_08_37_35_029_original.jpg',
  'https://im.haat.delivery/images/BusinessIcons/0_2025_10_13_06_37_23_834_original.jpg',
  'https://im.haat.delivery/images/BusinessIcons/0_2025_10_12_12_48_19_500_original.jpg',
  'https://im.haat.delivery/images/BusinessIcons/0_2025_10_12_06_13_17_646_original.jpg',
  'https://im.haat.delivery/images/BusinessIcons/0_2025_10_11_09_36_15_389_original.jpg',
  'https://im.haat.delivery/images/BusinessIcons/0_2025_10_09_08_23_48_124_original.jpg',
  'https://im.haat.delivery/images/BusinessIcons/0_2025_10_08_07_57_07_236_original.jpg',
  'https://im.haat.delivery/images/BusinessIcons/0_2025_10_08_07_06_44_253_original.jpg',
  'https://im.haat.delivery/images/BusinessIcons/0_2025_10_07_06_37_52_139_original.jpg',
  'https://im.haat.delivery/images/BusinessIcons/0_2025_10_06_10_01_22_045_original.jpg',
  'https://im.haat.delivery/images/BusinessIcons/8056_2025_10_09_06_11_03_316_original.jpg',
  'https://im.haat.delivery/images/BusinessIcons/0_2025_10_02_10_31_43_603_original.jpg',
  'https://im.haat.delivery/images/BusinessIcons/0_2025_10_02_09_23_47_252_original.jpg',
  'https://im.haat.delivery/images/ApplicationData/308_icon20211104215307.jpg',
  'https://im.haat.delivery/images/BusinessIcons/0_2025_07_13_07_56_41_865_original.jpg',
  'https://im.haat.delivery/images/BusinessIcons/0_2025_10_02_07_18_57_703_original.jpg',
  'https://im.haat.delivery/images/BusinessIcons/8048_2025_10_11_15_11_47_803_original.jpg',
  'https://im.haat.delivery/images/BusinessIcons/0_2025_10_02_05_48_28_782_original.jpg',
  'https://im.haat.delivery/images/BusinessIcons/0_2025_09_30_09_20_58_966_original.jpg',
  'https://im.haat.delivery/images/BusinessIcons/0_2025_09_28_09_05_43_843_original.jpg',
  'https://im.haat.delivery/images/BusinessIcons/0_2025_09_24_13_49_14_380_original.jpg',
  'https://im.haat.delivery/images/ApplicationData/130_icon20220101091133.jpg',
  'https://im.haat.delivery/images/ApplicationData/138720220612151339.jpg',
  'https://im.haat.delivery/images/ApplicationData/156020240201112945.jpg',
  'https://im.haat.delivery/images/ApplicationData/6_icon20220101081903.jpg',
  'https://im.haat.delivery/images/ApplicationData/6320231004085445.jpg',
  'https://im.haat.delivery/images/ApplicationData/12020221117063723.jpg',
  'https://im.haat.delivery/images/ApplicationData/49120220922091225.jpg',
  'https://im.haat.delivery/images/ApplicationData/740_icon20211104231746.jpg',
  'https://im.haat.delivery/images/ApplicationData/943_icon20211102162533.jpg',
  'https://im.haat.delivery/images/ApplicationData/155820221117064756.jpg',
  'https://im.haat.delivery/images/ApplicationData/165220221117064618.jpg',
  'https://im.haat.delivery/images/ApplicationData/196920221129135907.jpg',
  'https://im.haat.delivery/images/ApplicationData/331720230612110622.jpg',
  'https://im.haat.delivery/images/Market/icons/markets3613_2025_08_11_12_32_03_218_original.jpg',
  'https://im.haat.delivery/images/Market/Icons/401220230910080023.jpg',
  'https://im.haat.delivery/images/BusinessIcons/020240213133643.jpg',
  'https://im.haat.delivery/images/BusinessIcons/020241013062515_original.jpg',
  'https://im.haat.delivery/images/BusinessIcons/020241128065353_original.jpg',
  'https://im.haat.delivery/images/BusinessIcons/020250119065305_original.jpg',
  'https://im.haat.delivery/images/BusinessIcons/020250227085612_original.jpg',
  'https://im.haat.delivery/images/BusinessIcons/020250521072626_original.jpg',
  'https://im.haat.delivery/images/BusinessIcons/7649_2025_07_16_06_43_38_148_original.jpg',
  'https://im.haat.delivery/images/BusinessIcons/0_2025_07_22_10_32_12_543_original.jpg',
];
